import trashA from '../../icon/trashA.png';
import trashV from '../../icon/trashV.png';
import trashG from '../../icon/trashG.png';  
export const trashData={
    trashCan:[
        {
            icon:trashA,
            acepts:['metal','plastic'],
            name:'Plastic-Metal Bin',           
        },
        {
            icon:trashV,
            acepts:['organic','ordinary'],
            name:'Organic-Ordinary Bin',           
        },
        {
            icon:trashG,
            acepts:['paper','glass'],
            name:'Paper-Glass Bin',           
        },
    ],
}
export default trashData;